import { render } from "./AppTabsPage.vue?vue&type=template&id=87c5ac12&bindings={\"navRoute\":\"options\",\"subpages\":\"options\",\"changeTab\":\"options\",\"getAdjacentRoute\":\"options\",\"navigate\":\"options\"}"
import script from "./AppTabsPage.vue?vue&type=script&lang=js"
export * from "./AppTabsPage.vue?vue&type=script&lang=js"
script.render = render

export default script